module.exports = __webpack_public_path__ + "img/workflow.2db9a667.svg";